export const WaypointModel = {
    id: "",
    name: "",
    full_address: "",
    icon: "",
    type: "",
    lat: "",
    lng: "",
    time: 0
}
